<template>
  <div class="detail-container">
    <!-- 面包屑导航-->
    <div class="crumbs clearfix">
      <router-link tag="div" class="item fl cur" to="/reconciliation">
        <img class="location" src="@/assets/images/icon_dw_h@2x.png" alt="">
        <span class="text1">对账函清单 </span>
      </router-link>
      <span class="text2">{{ $route.query.khqrzt}}列表</span>

    </div>
    <!--  条件-->


    <!--  表格-->
    <div class="table-area">
      <table>
        <thead>

        <tr>
           <td>对账期间</td>
           <td>发货</td>
           <td>收款</td>
          <td>余额</td>
          <td>对账结果</td>
           <td>签字确认</td>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in list" :key="index" >

          <td style="text-decoration: underline" :class="['code-cell', item.ISREAD=='已读' ? 'read' : 'unread']" @click="goToDzhDetail(item)">{{ item.SCPKCODE }}</td>
           <td>{{ item.VFHDS }}</td>
           <td>{{ item.VSKJE }}</td>
          <td>{{ item.YUE }}</td>
          <td>{{ item.KHDZJG }}</td>
           <td>{{ item.KHQRZT }}</td>

        </tr>
        </tbody>
      </table>
      <el-empty v-if="list.length==0" description="暂无数据"></el-empty>
      <el-pagination v-if="list.length>0"
                     background
                     layout="prev, pager, next"
                     style="text-align: center"
                     @current-change="handleCurrentChange"
                     :page-size="pageSize"
                     :current-page="pageNum"
                     :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 0,
      count: 0,

    };
  },
  components: {},
  props: {},
  mounted() {
    this.getAllDetail();
  },
  methods: {
    rangeHandle(num) {
      this.pageNum = 1;
      this.getAllDetail()
    },

    searchHandle() {

      this.getAllDetail();
    },
    //创建方法er
    DateDiffer(Date_end) {
      //date1结束时间
      let date1 = new Date(Date_end);
      //date2当前时间
      let date2 = new Date();
      date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
      date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      const diff = date1.getTime() - date2.getTime(); //目标时间减去当前时间
      //计算当前时间与结束时间之间相差天数
      return Math.abs(diff / (24 * 60 * 60 * 1000));
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getAllDetail(1);
    },
    goToDzhDetail(item) {
      this.$router.push({
        path: 'dzdmx',
        query: {
          bindid: item.BINDID
        }
      });
    },
    async getAllDetail() {
      let res = await this.$api.getReconciliationMxList({
        custcode: this.$route.query.custcode,
        vunitname: this.$route.query.vunitname,
        khqrzt: this.$route.query.khqrzt,
        p: this.pageNum,
      });
      if (res.code == 1) {
        this.pageSize = res.data.pageSize;
        this.count = res.data.count;
        this.list = res.data.list;
      } else {
        this.$message.error(res.msg);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  min-height: $main-height;
  padding-top: 46px;

  .crumbs {
    width: 1200px;
    margin: 0 auto;

    .location {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
    }

    .text1 {
      vertical-align: middle;
      font-size: 16px;
      color: #999999;
    }

    .text2 {
      vertical-align: middle;
      font-size: 16px;
      color: $color-primary;
    }
  }

  td {
    line-height: 24px;
    /*padding: 40px!important;*/
  }

  .fl {
    float: left;
    margin-right: 5px;
  }

  .form {
    width: 1200px;
    margin: 20px auto 26px;

    .date-range {
      float: left;

      .date-input /*其实日期*/
      {
        float: left;
        vertical-align: middle;

        span {
          font-size: 14px;
          color: #333333;
          margin-right: 5px;
        }

        .date-box {
          display: inline-block;
          vertical-align: middle;
          width: 251px;
          height: 40px;
          background: #FFFFFF;
          border: 1px solid #DADADA;
          padding: 0 10px;

          ::v-deep.el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 200px;
          }

          ::v-deep.el-input__inner {
            border: none;
            height: 38px;
          }

          ::v-deep.el-input__prefix, .el-input__suffix {
            display: none;
          }

          > img {
            float: right;
            width: 20px;
            margin-top: 10px;
          }
        }
      }

      //时间段选择
      .date-group {
        float: left;
        overflow: hidden;
        margin-left: 30px;

        .item {
          cursor: pointer;
          float: left;
          width: 89px;
          height: 40px;
          background: #FFFFFF;
          border: 1px solid #999999;
          margin-right: 10px;
          text-align: center;
          line-height: 40px;

          font-size: 14px;
          color: #999999;
        }

        > .active {
          background-color: $color-primary;
          font-size: 14px;
          color: #FFFFFF;
          border: none;
        }
      }

      .search {
        cursor: pointer;
        float: left;
        width: 89px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin-left: 40px;

        background-color: #D70D18;
        font-size: 14px;
        color: #FFFFFF;
        border-radius: 20px;

      }

    }

    .output {
      float: right;
      cursor: pointer;

      img {
        vertical-align: middle;
        width: 34px;
        height: 34px;
        margin-right: 7px;
      }

      span {
        vertical-align: middle;
        font-size: 14px;
        color: #333333;
      }
    }
  }

  .table-area {
    width: 1200px;
    margin: 22px auto 86px;

    table {
      width: 100%;

      tr {
        height: 60px;

        td {
          vertical-align: middle;
          font-size: 16px;
          text-align: left;
          &:first-child{padding-left: 40px;}
        }
      }

      thead {
        tr {
          background-color: $color-primary;

          td {
            color: #FFFFFF;
          }

        }
      }

      tbody {
        tr {
          &:nth-child(2n) {
            background-color: #F9F9F9;
          }

          td {
            &:nth-child(4) {
              color: $color-primary
            }

          }
        }
      }
    }
  }

  ::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #D70D18;
  }
}
.unread {
  font-weight: 800;
  color: #2c3e50;
}
.read {
  font-weight: normal;
}
</style>